export const RemoveUnavailableSlots = (times, slots) => {
    let forDeletion;
    for (let i = 0; i<times.length; i++){
        forDeletion = createSubArray(times[i]);
        // eslint-disable-next-line no-loop-func
        slots = slots.filter(item => !forDeletion.includes(item))
    }
    return slots;
}

const createSubArray = (oneTime) => {
    let subArray = []
    for (let i = oneTime.start; i < oneTime.end + 1; i++){
        subArray.push(i);
    }
    return subArray
}

